// Shared layout constants and utilities for the portfolio report canvas system.
// Grid: 12 columns × 53 rows maps to A4 content area (184.6mm × 266.3mm).

export const GRID_COLS = 12;
export const GRID_ROWS = 53;

// Default sizes for block types when first added — all full width
const DEFAULT_BLOCK_SIZES = {
  title_box: { w: 12, h: 6 },
  intro_text: { w: 12, h: 8 },
  market_overview: { w: 12, h: 8 },
  performance_review: { w: 12, h: 8 },
  perf_table: { w: 12, h: 10 },
  fy_table: { w: 12, h: 10 },
  holdings_and_characteristics: { w: 12, h: 10 },
  charts_tilts_and_allocation: { w: 12, h: 12 },
  allocation_donut_chart: { w: 12, h: 12 },
  historical_allocation_chart: { w: 12, h: 12 },
  corporate_debt_review: { w: 12, h: 8 },
  credit_exposure_chart: { w: 12, h: 10 },
  government_bonds_review: { w: 12, h: 8 },
  international_equities_review: { w: 12, h: 8 },
  australian_equities_review: { w: 12, h: 8 },
  real_assets_review: { w: 12, h: 8 },
  global_alpha_review: { w: 12, h: 8 },
  outlook: { w: 12, h: 10 },
  sign_off: { w: 12, h: 5 },
};

const DEFAULT_SIZE = { w: 12, h: 8 };

/** Get default w/h for a block when it has no layout position yet */
export function getDefaultBlockSize(blockId) {
  if (DEFAULT_BLOCK_SIZES[blockId]) return DEFAULT_BLOCK_SIZES[blockId];
  if (blockId.startsWith('custom_text')) return { w: 12, h: 8 };
  if (blockId.startsWith('custom_disclaimer')) return { w: 12, h: 8 };
  if (blockId.startsWith('tpl_')) return { w: 12, h: 10 };
  return DEFAULT_SIZE;
}

/**
 * Migrate a page's blocks from old format (string[]) to new format (object[]).
 * Stacks blocks vertically at full width with estimated heights.
 */
export function migratePageBlocks(blocks) {
  if (!blocks || blocks.length === 0) return [];
  if (typeof blocks[0] === 'object' && blocks[0].id) return blocks;
  let y = 0;
  return blocks.map(blockId => {
    const size = getDefaultBlockSize(blockId);
    const item = { id: blockId, x: 0, y, w: size.w, h: size.h };
    y += size.h;
    return item;
  });
}
